import React from "react";

function Following() {
  return <div>Following</div>;
}

export default Following;
